import { Avatar } from '@mantine/core';

import useFetchUser from 'src/Hooks/Queries/useFetchUser';

import { Props } from './UserAvatar.props';

const UserAvatar = ({ size, user: _user, opaque = false }: Props) => {
  const { data: me } = useFetchUser({ enabled: !_user });

  const user = _user ?? me;
  const firstName = user?.firstName ?? '';
  const lastName = user?.lastName ?? '';
  const initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();

  return (
    <Avatar
      src={user?.profilePictureUrl}
      color="initials"
      size={size}
      name={initials}
      bg={opaque ? 'white' : undefined}
    />
  );
};

export default UserAvatar;
